const {fetch} = global;
import queryString from 'query-string';

export default query => {
	let endpoint = `${process.env.GATSBY_FUNCTION_PATH}/search-products-count`;
	let searchQuery = queryString.stringify(query, {arrayFormat: 'comma'});

	if (searchQuery) {
		endpoint += `?${searchQuery}`;
	}

	return fetch(endpoint)
		.then(res => res.json());
};